const useTinySettings = () => {
    const getMarketplace = () => {
        return JSON.parse(localStorage.getItem('marketplace') || '{}');
    };
    const setMarketplace = (marketplace) => {
        localStorage.setItem('marketplace', JSON.stringify(marketplace));
    };
    const getWirisPlugin = () => {
        var _a;
        const marketplace = getMarketplace();
        return (_a = marketplace === null || marketplace === void 0 ? void 0 : marketplace.plugins) === null || _a === void 0 ? void 0 : _a.find((plugin) => plugin.description.includes('Wiris'));
    };
    const getWirisSetting = (settingName) => {
        var _a;
        const wirisPlugin = getWirisPlugin();
        return (wirisPlugin === null || wirisPlugin === void 0 ? void 0 : wirisPlugin.isEnabled)
            ? (_a = wirisPlugin === null || wirisPlugin === void 0 ? void 0 : wirisPlugin.settings.find((settings) => settings.name === settingName)) === null || _a === void 0 ? void 0 : _a.value
            : '';
    };
    return { setMarketplace, getWirisPlugin, getWirisSetting };
};
export default useTinySettings;
